"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaMixin = void 0;
var _styledComponents = require("styled-components");
var _mediaBreakpointMixin = require("./mediaBreakpointMixin");
/** @mixin mediaMixin */
/**
 * Adds styles at the given token breakpoint.
 *
 * @example
 * import { css } from 'styled-components';
 * import { mediaMixin } from '@zillow/constellation';
 *
 * const styles = css`
 *     color: red;
 * `;
 *
 * const Component = styled.div`
 *     ${mediaMixin('md', styles)}
 * `;
 *
 * <Component>This text will be red at the "md" breakpoint</Component>
 *
 * @method
 * @param {string} breakpoint - A breakpoint media token. By default, the styles will apply to sizes
 *     greater than or equal (gte) to the the breakpoint value. You can also apply styles at sizes
 *     less than or equal (lte), or exactly equal by appending to the breakpoint,
 *     e.g. sm_lte, md_eq, lg_gte.
 * @param {CSSObject} styles - The styles that should be applied at the given breakpoint.
 * @return {Interpolation}
 */
var mediaMixin = function mediaMixin(breakpoint, styles) {
  return function (mediaProps) {
    return (0, _styledComponents.css)(["@media ", "{", "}"], (0, _mediaBreakpointMixin.mediaBreakpointMixin)(breakpoint), typeof styles === 'function' ? styles(mediaProps) : styles);
  };
};
exports.mediaMixin = mediaMixin;